import React from "react";
import { Routes, Route } from "react-router-dom";

import Sidebar from "../components/common/Sidebar";
import "../styles/dashboard/Admin/AdminPortal.css";

// SubAdmin Components
import SubAdminHome from "../components/dashboard/SubAdmin/SubAdminHome";

// Import shared components for SubAdmin access
import OrganizationManagement from "../components/dashboard/shared/OrganizationManagement";
import UserManagement from "../components/dashboard/shared/UserManagement";
import UploadDataManagement from "../components/dashboard/shared/UploadDataManagement";
import TransactionHistory from "../components/dashboard/shared/TransactionHistory";
import CreditReportManagement from "../components/dashboard/shared/CreditReportManagement";
import ReportManagement from "../components/dashboard/SubAdmin/ReportManagement";
import Profile from "../pages/Profile";

export default function SubAdminPortal() {
  return (
    <div className="dashboard-layout">
      <Sidebar role="subadmin" />
      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<SubAdminHome />} />
          <Route path="dashboard" element={<SubAdminHome />} />
          <Route path="organizations" element={<OrganizationManagement role="subadmin" />} />
          <Route path="users" element={<UserManagement role="subadmin" />} />
          <Route path="uploaded-data" element={
            <UploadDataManagement
              role="subadmin"
              uploadEndpoint="/v1/sub-admin/data-upload/upload"
              historyEndpoint="/v1/sub-admin/data-upload/history"
              authHeader={() => require('../services/orgUserAuth.service').default.getAuthHeader()}
              orgSelection={true}
              organizations={[]}
            />
          } />
          <Route path="transaction-history" element={<TransactionHistory role="subadmin" />} />
          <Route path="credit-reports" element={<CreditReportManagement role="subadmin" />} />
          <Route path="reports" element={<ReportManagement role="subadmin" />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<h2>404 - Page Not Found</h2>} />
        </Routes>
      </div>
    </div>
  );
}